export {
  SubPageTabs,
  resolveActiveTab,
  type SubPageTabsProps,
  type SubPageTab,
} from './sub-page-tabs';
